__webpack_require__.p = "https://oss-assets.amberstudent.cn/amber-user-website/VP1-8.52.6-33e1-amber-user-website-prod-cn-1822/assets/";